import React, { useState, useEffect } from "react";
import DefineMedia from "../../../_default/DefineMedia";
import isIterable from "../../../../services/defaultFunctions/isIterable";
import { addFrontImageClient, addSideImageClient, addBackImageClient } from "../../../../services/firebase/firestore/saveData";
import "./Progress.scss";
import { getDailyMeasurementProgress } from "../../../../services/firebase/firestore/getData";
import Icon from "../../../_default/Icon";

export default function Progress({ measurements, client_id, time, currentTime }) {
    const [imageFront, setImageFront] = useState(false);
    const [imageSide, setImageSide] = useState(false);
    const [imageBack, setImageBack] = useState(false);
    const from = "coach";
    const [deleteUrlArray, setDeleteUrlArray] = useState(false);
    const [triceps, setTriceps] = useState('??');
    const [chest, setChest] = useState('??');
    const [hip, setHip] = useState('??');
    const [thigh, setThigh] = useState('??');
    const [belly, setBelly] = useState('??');
    const [subscapula, setSubscapula] = useState('??');
    const [midaxillary, setMidaxillary] = useState('??');
    const [weight, setWeight] = useState('??');
    const [bodyfat, setBodyfat] = useState('??');
    const [bmi, setBmi] = useState("??");
    const [sumCalculation,setSumCalculation]=useState(0)

    useEffect(() => {
        getDailyMeasurementProgress(client_id, time, currentTime, (result) => {
            console.log("measuerment progress", result);
            if (result?.images?.front) {
                setImageFront(result.images.front);
            }
            if (result?.images?.side) {
                setImageSide(result.images?.side);
            }
            if (result?.images?.back) {
                setImageBack(result.images?.back);
            }
            setTriceps(result.triceps);
            setChest(result.chest);
            setHip(result.hip);
            setThigh(result.thigh);
            setBelly(result.belly);
            setSubscapula(result.subscapula);
            setMidaxillary(result.midaxillary);
            setWeight(result.weight);
            setBodyfat(result.bodyfat);
            setBmi(result.bmi);
            let calculation=parseFloat(result.triceps)+parseFloat(result.chest)+parseFloat(result.hip)+parseFloat(result.thigh)+parseFloat(result.belly)+parseFloat(result.subscapula)+parseFloat(result.midaxillary)
            setSumCalculation(calculation)
        })
    }, [client_id, time, currentTime]);

    const addToDeleteUrl = (pageType, url) => {
        let _deleteUrlArray = isIterable(deleteUrlArray) ? [...deleteUrlArray] : [];
        _deleteUrlArray.push(url);
        setDeleteUrlArray(_deleteUrlArray);
    };

    const addFrontImage = (e) => {
        setImageFront(e);
        addFrontImageClient(client_id, time, e);
    }

    const addSideImage = (e) => {
        setImageSide(e);
        console.log(client_id, time, e);
        addSideImageClient(client_id, time, e);
    }

    const addBackImage = (e) => {
        setImageBack(e);
        addBackImageClient(client_id, time, e);
    }
    async function downloadImage(imageSrc,imageName) {
        const image = await fetch(imageSrc)
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)
        // console.log("image src",imageSrc,imageFront)
        const link = document.createElement('a')
        link.href = imageURL
        link.download = imageName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    return (
        <div className="c-calendar-progress-container">
            <div className="c-progress-data-container">
                <section style={{ position: "relative" }}>
                    <div className="c-image">
                       {
                        imageFront?
                        <span onClick={()=>downloadImage(imageFront,"frontImage")} className="donwload-icon">

                            <Icon icon="download" />
                        </span>:""
                       }
                        
                        <DefineMedia isAdmin={true} errorStyles={{ width: "150px", position: "initial", marginTop: "20px" }} media={imageFront} pageType={"image"} storageUrl={`${from === "coach" ? "clients/" + client_id : "aurum"}/workoutProgress/`} onMediaChange={(e) => addFrontImage(e)} addToDeleteUrl={addToDeleteUrl} />
                        <p className="c-image-sub">Front</p>
                    </div>
                </section>
                <section style={{ position: "relative" }}>
                    <div className="c-image">
                        {
                            imageSide?
                            <span onClick={()=>downloadImage(imageSide,"sideImage")} className="donwload-icon">

                            <Icon icon="download" />
                        </span>:""
                        }
                        
                        <DefineMedia isAdmin={true} errorStyles={{ width: "150px", position: "initial", marginTop: "20px" }} media={imageSide} pageType={"image"} storageUrl={`${from === "coach" ? "clients/" + client_id : "aurum"}/workoutProgress/`} onMediaChange={(e) => addSideImage(e)} addToDeleteUrl={addToDeleteUrl} />
                        <p className="c-image-sub">Side</p>
                    </div>
                </section>
                <section style={{ position: "relative" }}>
                    <div className="c-image">
                        {
                            imageBack?
                            <span onClick={()=>downloadImage(imageBack,"backImage")} className="donwload-icon">

                            <Icon icon="download" />
                        </span>:""
                        }
                        <DefineMedia isAdmin={true} errorStyles={{ width: "150px", position: "initial", marginTop: "20px" }} media={imageBack} pageType={"image"} storageUrl={`${from === "coach" ? "clients/" + client_id : "aurum"}/workoutProgress/`} onMediaChange={(e) => addBackImage(e)} addToDeleteUrl={addToDeleteUrl} />
                        <p className="c-image-sub">Back</p>
                    </div>
                </section>
            </div>
            <div className="c-progress-data-details-container">
                <div className="c-progress-data-details-left">
                    <h1>Main details</h1>
                    <div className="c-progress-data-details-list">
                        <div className="c-progress-data-details-listitem"><p>Weight</p> <p>{weight ? weight + "kg" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Bmi</p> <p>{bmi ? bmi : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Bodyfat</p> <p>{bodyfat ? bodyfat + "%" : "--"}</p></div>
                    </div>
                </div>
                <div className="c-progress-data-details-right">
                    <h1>Skinfolds</h1>
                    <br />
                    <div className="c-progress-data-details-list">
                        <div className="c-progress-data-details-listitem"><p>Tricep</p> <p>{triceps ? triceps + "mm" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Chest</p> <p>{chest ? chest + "mm" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Subscapular</p> <p>{subscapula ? subscapula + "mm" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Midaxillary</p> <p>{midaxillary ? midaxillary + "mm" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Thigh</p> <p>{thigh ? thigh + "mm" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Umbilical</p> <p>{belly ? belly + "mm" : "--"}</p></div>
                        <div className="c-progress-data-details-listitem"><p>Hip</p> <p>{hip ? hip + "mm" : "--"}</p></div>
                        <br />
                        <div className="c-progress-data-details-listitem"><p><b>Total Sum</b></p> <p>{sumCalculation ? sumCalculation + "mm" : "--"}</p></div>
                    </div>
                </div>
            </div>
        </div>
    );
}